import { useIsMobile } from "./Hooks";
import { FxIdSdkAdapterForVkCom } from "../../SDK/FxIdSdkAdapterForVkCom";
import { FxIdSdkAdapterForVkPlay } from "../../SDK/FxIdSdkAdapterForVkPlay";
import { webPlayerStore } from "./store/webPlayerStore";

export const useShowHeader = () => {
	const isMobile = useIsMobile();
	const adapter = webPlayerStore((state) => state.adapter);

	try {
		// На некоторых сайтах есть своя менюшка в мобилке. Нашу показывать не надо
		const domainsMenuGated = [FxIdSdkAdapterForVkCom.VkComDirectHost, FxIdSdkAdapterForVkPlay.VkPlayHost];

		const ancestorOrigins = location.ancestorOrigins;
		const url =
			ancestorOrigins == null || ancestorOrigins[0] == null
				? new URL(location.origin)
				: new URL(location.ancestorOrigins[0]);
		const host = url.host;

		//Скрытие меню на мобильниках в VkPlay
		if (isMobile && domainsMenuGated.includes(host)) {
			return false;
		}

		//Скрытие меню на мобильниках в Ok
		if (isMobile && adapter === "ok") {
			return false;
		}

		if (adapter === "telegram") {
			return false;
		}
	} catch (error) {
		log.error(error);
	}
	return true;
};
